import Select from "react-select";
import { useState, useEffect } from "react";
import { es } from "date-fns/locale";
import { DatePicker } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import ReactModal from "react-modal";
import { available_destinies } from "../utils/api/available_destinies.js";
import { isNational, isBaleares, isCanary } from "../utils/port_locations.js";

export function SearchBox({ searchData, changeSection }) {
  const options = [
    { value: "ALG", label: "Algeciras" },
    { value: "CEU", label: "Ceuta" },
    { value: "TRF", label: "Tarifa" },
  ];

  // { value: "ACE", label: "Lanzarote" },
  // { value: "AGA", label: "Agadir" },
  // { value: "AGP", label: "Málaga" },
  // { value: "ALD", label: "Alcudia" },
  // { value: "ALG", label: "Algeciras" },
  // { valie: "ALC", label: "Alicante" },
  // { value: "AHU", label: "Alhucemas" },
  // { value: "ARG", label: "Argel" },
  // { value: "BCN", label: "Barcelona" },
  // { value: "CDI", label: "Cádiz" },
  // { value: "CEU", label: "Ceuta" },
  // { value: "CIU", label: "Ciudadela" },
  // { value: "CRT", label: "Cartagena" },
  // { value: "DEN", label: "Denia" },
  // { value: "IBZ", label: "Ibiza" },
  // { value: "FOR", label: "Formentera" },
  // { value: "FUE", label: "Fuerteventura" },
  // { value: "GHZ", label: "Granadghazaouetilla" },
  // { value: "GIB", label: "Gibraltar" },
  // { value: "HUV", label: "Huelva" },
  // { value: "LEI", label: "Almería" },
  // { value: "LPA", label: "Las Palmas" },
  // { value: "MAH", label: "Mahón" },
  // { value: "MJB", label: "Morro Jable" },
  // { value: "MLN", label: "Melilla"},
  // { value: "MOS", label: "Mostaganem" },
  // { value: "MOT", label: "Motril" },
  // { value: "NDR", label: "Nador" },
  // { value: "ORN", label: "Orán" },
  // { value: "ORZ", label: "Orzola" },
  // { value: "PMI", label: "Palma de Mallorca" },
  // { value: "QFU", label: "Puerto del Rosario" },
  // { value: "QIU",}
  // { value: "QLY", label: "Puerto de la Luz" },
  // { value: "SET"}
  // { value: "SPC", label: "Santa Cruz de Tenerife" },
  // { value: "TAN", label: "Tanger" },
  // { value: "TCI"}
  // { value: "TGM", label: "Tanger Med" },
  // { value: "TRF", label: "Tarifa" },
  // { value: "VDE",  },
  // { value: "VLC", label: "Valencia" },
  // { value: "VGR", },
  // // "GMR"
  // // "GRA"
  // // "PSA"


  const [way, setWay] = useState("round_trip");
  const [origen, setOrigen] = useState();
  const [destinies, setDestinies] = useState();
  const [destiny, setDestiny] = useState();
  const [departureDate, setDepartureDate] = useState();
  const [returnDate, setReturnDate] = useState();
  const [modalPasajeros, setModalPasajeros] = useState(false);
  const [modalVehiculos, setModalVehiculos] = useState(false);
  const [modalBonificaciones, setModalBonificaciones] = useState(false);
  const [numAdults, setNumAdults] = useState(1);
  const [numKids, setNumKids] = useState(0);
  const [numBabies, setNumBabies] = useState(0);
  const [vehicleType, setVehicleType] = useState();
  const [vehicleHeight, setVehicleHeight] = useState();
  const [vehicleLong, setVehicleLong] = useState();
  const [vehicleTrailer, setVehicleTrailer] = useState();
  const [vehicleTrailerHeight, setVehicleTrailerHeight] = useState();
  const [vehicleTrailerLong, setVehicleTrailerLong] = useState();
  const [advantage, setAdvantage] = useState();
  const [family, setFamily] = useState();
  const [canHaveAdvantage, setCanHaveAdvantage] = useState(false);
  const [residence, setResidence] = useState();
  const [residenceType, setResidenceType] = useState(null);



  const fixDate = (date) => {
    if (date === undefined) {
      return;
    }

    const stringDate = date.toISOString();
    return stringDate;
  }

  useEffect(() => {
    if (origen !== undefined) {
      getDestinies(origen).then((d) => {
        setDestinies(d);
      });
    }
  }, [origen]);

  useEffect(() => {
    setResidenceType(null);
    setCanHaveAdvantage(false);
    if (destiny !== undefined) {
      if (isNational(origen) && isNational(destiny)) {
        setCanHaveAdvantage(true);
        if (
          origen === "CEU" ||
          destiny === "CEU" ||
          origen === "MLN" ||
          origen === "MLN"
        ) {
          setResidenceType("ceuta/melilla");
        }
        if (isBaleares(origen) || isBaleares(destiny)) {
          setResidenceType("baleares");
        }
        if (isCanary(origen) || isCanary(destiny)) {
          setResidenceType("canarias");
        }
      }
    }
  }, [destiny, origen]);

  useEffect(() => {
    if (numAdults < 0) {
      setNumAdults(0);
    }
  }, [numAdults]);

  useEffect(() => {
    if (numKids < 0) {
      setNumKids(0);
    }
  }, [numKids]);

  useEffect(() => {
    if (numBabies < 0) {
      setNumBabies(0);
    }
  }, [numBabies]);

  function closePassengersModal() {
    if (numAdults > 0 || numKids > 0 || numBabies > 0) {
      setModalPasajeros(false);
    }
  }

  function submitSearch() {
    searchData({
      origen: origen,
      destiny: destiny,
      way: way,
      departureDate: fixDate(departureDate),
      returnDate: fixDate(returnDate),
      numAdults: numAdults,
      numKids: numKids,
      numBabies: numBabies,
      vehicleType: vehicleType,
      vehicleLong: vehicleLong,
      vehicleTrailer: vehicleTrailer,
      vehicleTrailerLong: vehicleTrailerLong,
      vehicleTrailerHeight: vehicleTrailerHeight,
      bonificacion: advantage,
      fam_numerosa: family,
      residente: residence,
    });
    changeSection("select");
  }

  async function getDestinies(origen) {
    const destinies = await available_destinies(origen);
    return destinies;
  }

  return (
    <>
      <div className="m-bxFormHome">
        <div className="bx">
          <div className="row">
           
            <button
              className={
                way === "round_trip" ? "btnBlue-m" : "btnBlue-m-outline"
              }
              id="btnIdaVuelta"
              onClick={() => setWay("round_trip")}
            >
              IDA Y VUELTA
            </button>
             <button
              className={way === "one_way" ? "btnBlue-m" : "btnBlue-m-outline"}
              id="btnIda"
              onClick={() => setWay("one_way")}
            >
              IDA
            </button>
          </div>
          <div className="row x2">
            <div className="col">
              Puerto de origen
              <Select onChange={(e) => setOrigen(e.value)} options={options} />
            </div>
            <div className="col">
              {origen && (
                <>
                  Puerto de destino
                  <Select
                    onChange={(e) => setDestiny(e.value)}
                    options={destinies}
                  />
                </>
              )}
            </div>
          </div>
          <div className="row x2">
            <div className="col">
              <div className="m-frmGroup m-frmGroup--fechaIda">
                {destiny && (
                  <>
                    Fecha de Salida
                    <DatePicker
                      minimumDate = {new Date()}
                      date={departureDate}
                      onDateChange={setDepartureDate}
                      locale={es}
                      format='dd/MM/yyyy' 
                    >
                      {({ inputProps, focused }) => (
                        <input
                          className={"input" + (focused ? " -focused" : "")}
                          {...inputProps}
                        />
                      )}
                    </DatePicker>
                  </>
                )}
              </div>
            </div>
            <div className="col">
              <div className="m-frmGroup m-frmGroup--fechaIda">
                {destiny && way === "round_trip" && (
                  <>
                    Fecha de regreso
                    <DatePicker
                      minimumDate = {departureDate}
                      date={returnDate}
                      onDateChange={setReturnDate}
                      locale={es}
                    >
                      {({ inputProps, focused }) => (
                        <input
                          className={"input" + (focused ? " -focused" : "")}
                          {...inputProps}
                        />
                      )}
                    </DatePicker>
                  </>
                )}
              </div>
            </div>
          </div>
          {((returnDate && way === "round_trip") ||
            (departureDate && way === "one_way")) && (
            <>
              <div className="row x2">
                <div className="col">
                  <div
                    className="m-frmGroup m-frmGroup--pasajeros"
                    id="m-frmGroupPasajeros"
                  >
                    <button
                      onClick={() => {
                        setModalPasajeros(true);
                      }}
                      className="btnOrange-m btn-full"
                      id="inputPasajeros"
                    >
                      Pasajeros
                    </button>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="m-frmGroup m-frmGroup--pasajeros"
                    id="m-frmGroupPasajeros"
                  >
                    <button
                      className="btnOrange-m btn-full"
                      id="inputPasajeros"
                      onClick={() => {
                        setModalVehiculos(true);
                      }}
                    >
                      Vehiculo
                    </button>
                  </div>
                </div>
              </div>
              <div className="row x2">
                <div className="col">
                  <div className="m-frmGroup">
                    <button
                      className="btnOrange-m btn-full"
                      id="inputPasajeros"
                      onClick={() => {
                        setModalBonificaciones(true);
                      }}
                    >
                      Bonificaciones
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <button
                  className="btnOrange-l btnArrow-l"
                  onClick={() => {
                    submitSearch();
                  }}
                >
                  Buscar
                </button>
                ;
              </div>
            </>
          )}
        </div>
      </div>
      <ReactModal
        isOpen={modalPasajeros}
        className="modal-pasajeros o-frmPasajeros"
        appElement={document.getElementById("root")}
      >
        <div className="o-frmPasajeros__bx">
          <div className="m-frmTipoPas">
            <div className="m-frmTipoPas__tit">
              <span>Adultos</span>
              <span>Mayores de 14 años</span>
            </div>
            <div className="m-frmTipoPas__num">
              <div className="m-frmGroup m-formNumberMore">
                <div
                  onClick={() => {
                    setNumAdults(numAdults - 1);
                  }}
                >
                  {" "}
                  -{" "}
                </div>
                <input
                  type="number"
                  id="niños"
                  name="niños"
                  className="formIdNumber"
                  value={numAdults}
                  step="1"
                  min="0"
                  max="10"
                />
                <div
                  onClick={() => {
                    setNumAdults(numAdults + 1);
                  }}
                >
                  {" "}
                  +{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="m-frmTipoPas">
            <div className="m-frmTipoPas__tit">
              <span>Niños</span>
              <span>De 1 a 13 años</span>
            </div>
            <div className="m-frmTipoPas__num">
              <div className="m-frmGroup m-formNumberMore">
                <div
                  onClick={() => {
                    setNumKids(numKids - 1);
                  }}
                >
                  {" "}
                  -{" "}
                </div>
                <input
                  type="number"
                  id="niños"
                  name="niños"
                  className="formIdNumber"
                  value={numKids}
                  step="1"
                  min="0"
                  max="10"
                />
                <div
                  onClick={() => {
                    setNumKids(numKids + 1);
                  }}
                >
                  {" "}
                  +{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="m-frmTipoPas">
            <div className="m-frmTipoPas__tit">
              <span>Bebes</span>
              <span>De 0 a 1 años</span>
            </div>
            <div className="m-frmTipoPas__num">
              <div className="m-frmGroup m-formNumberMore">
                <div
                  onClick={() => {
                    setNumBabies(numBabies - 1);
                  }}
                >
                  {" "}
                  -{" "}
                </div>
                <input
                  type="number"
                  id="bebes"
                  name="bebes"
                  className="formIdNumber"
                  value={numBabies}
                  step="1"
                  min="0"
                  max="10"
                />
                <div
                  onClick={() => {
                    setNumBabies(numBabies + 1);
                  }}
                >
                  {" "}
                  +{" "}
                </div>
              </div>
            </div>
          </div>
          <button
            className="btnOrange-m btn-full"
            onClick={() => {
              closePassengersModal();
            }}
          >
            Guardar
          </button>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={modalVehiculos}
        className="o-frmVehiculo modal-vehiculos"
        appElement={document.getElementById("root")}
      >
        <div className="o-frmVehiculo__bx">
          <div className="m-frmGroup">
            Tipo de vehículo
            <select
              id="typeVehi"
              className="vehiculo_modal"
              value={vehicleType}
              onChange={(e) => setVehicleType(e.target.value)}
            >
              <option disabled>Tipo</option>
              <option value="">No</option>
              <option value="tur">Turismo</option>
              <option value="B1">Bicicleta</option>
              <option value="FG">Furgoneta</option>
              <option value="AC">Autocaravana</option>
              <option value="MB">Motocicleta</option>
              <option value="PE">Patinete eléctrico</option>
            </select>
          </div>
          <div className="m-frmGroup is-error col-vehiculos">
            Altura <small>en m</small>
            <input
              type="number"
              name="height_modal"
              id="altura"
              placeholder="120"
              value={vehicleHeight}
              onChange={(e) => setVehicleHeight(e.target.value)}
            />
          </div>
          <div className="m-frmGroup col-vehiculos">
            Longitud <small>en m</small>
            <input
              type="number"
              id="longitud"
              name="long_modal"
              placeholder="120"
              value={vehicleLong}
              onChange={(e) => setVehicleLong(e.target.value)}
            />
          </div>
        </div>
        <div className="o-frmVehiculo__bx">
          <div
            className="m-frmGroup m-frmGroup--min "
            value={vehicleTrailer}
            onChange={(e) => setVehicleTrailer(e.target.value)}
          >
            Remolque
            <select id="typeVehi_remolque" name="remolque_modal">
              <option value="no">No</option>
              <option value="remolque">Remolque</option>
              <option value="caravana">Caravana</option>
            </select>
          </div>

          <div className="m-frmGroup m-frmGroup--min col-vehiculos">
            Altura <small>en m</small>
            <input
              type="number"
              name="special_height_modal"
              id="altura_remolque"
              placeholder="120"
              value={vehicleTrailerHeight}
              onChange={(e) => setVehicleTrailerHeight(e.target.value)}
            />
          </div>
          <div className="m-frmGroup m-frmGroup--min col-vehiculos">
            Longitud <small>en m</small>
            <input
              type="number"
              name="special_long_modal"
              id="longitud_remolque"
              placeholder="120"
              value={vehicleTrailerLong}
              onChange={(e) => setVehicleTrailerLong(e.target.value)}
            />
          </div>
        </div>
        <button
          className="btnOrange-m btn-full"
          onClick={() => {
            setModalVehiculos(false);
          }}
        >
          Guardar
        </button>
      </ReactModal>
      <ReactModal
        isOpen={modalBonificaciones}
        className=" "
        appElement={document.getElementById("root")}
      >
        <div className="modal-bonificaciones">
          <div className="bx" data-dismiss="o-modal">
            <div className="o-modal__content">
              <div className="o-modal__header">
                <div className="bx">
                  <div className="ht-four-medium">Bonificaciones</div>
                </div>
              </div>
              <div className="o-modal__body">
                <div className="bx">
                  <div className="m-frmGroup is-error">
                    Residente
                    <select
                      id="residente"
                      name="residente"
                      value={residence}
                      onChange={(e) => setResidence(e.target.value)}
                    >
                      <option value="no">No</option>
                      {canHaveAdvantage && residenceType !== null && (
                        <>
                          <option value={residenceType}>{residenceType}</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="m-frmGroup m-frmGroup--text">
                    <p className="hide">
                      Es la concedida a los servicios regulares de transporte
                      marítimo otorgada por el estado y que solo será aplicable
                      a los ciudadanos españoles y resto de la UE que hayan
                      obtenido la residencia en: CEUTA, MELILLA, ISLAS BALEARES,
                      ISLAS CANARIAS. Será requisito que el trayecto tenga
                      salida o llegada a algún punto de su comunidad/ciudad de
                      residencia. DOCUMENTACIÓN NECESARIA: Certificado de
                      empadronamiento expedido por el ayuntamiento, junto con su
                      D.N.I. o documento identificativo (caso de los extranjeros
                      nacionales de la UE)Españoles menores de 14 años
                      únicamente certificado de empadronamiento. Para cualquier
                      duda consulte con la naviera.
                    </p>
                  </div>
                  <div className="m-frmGroup">
                    Bonificación
                    <select
                      id="bonificacion"
                      name="bonificacion"
                      className="bonificacion"
                      value={advantage}
                      onChange={(e) => setAdvantage(e.target.value)}
                    >
                      <option value="">No</option>
                      {canHaveAdvantage && (
                        <>
                          <option value="ET3">
                            Ejercito de Tierra
                          </option>
                          <option value="FN3">
                            Fuerzas Navales
                          </option>
                          <option value="MIL">Cuerpos comunes del ejercito</option>
                          <option value="GCS">Guardia Civil</option>
                          <option value="POL">Policía</option>
                          <option value="CJ">Carné Joven</option>
                          <option value="tercera">Tercera Edad</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="m-frmGroup">
                    Familia numerosa
                    <select
                      id="f_numerosa"
                      name="f_numerosa"
                      className="family"
                      value={family}
                      onChange={(e) => setFamily(e.target.value)}
                    >
                      <option value="">No</option>
                      {canHaveAdvantage && (
                        <>
                          <option value="FNESPECIAL">
                            Familia Numerosa ESPECIAL
                          </option>
                          <option value="FNGENERAL">
                            Familia Numerosa GENERAL
                          </option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="m-frmGroup m-frmGroup--text">
                    <p className="hide">
                      {" "}
                      Para beneficiarse de cualquiera de las bonificaciones
                      existentes en PortalFerry es necesario que pueda acreditar
                      su condición de bonificado. Siendo responsabilidad y
                      obligación del viajero presentar la documentación
                      pertinente a la hora de la emisión de la tarjeta de
                      embarque.{" "}
                    </p>
                  </div>
                  <div className="m-frmGroup">
                    <div
                      className="btnOrange-m btn-full"
                      data-dismiss="o-modal"
                      onClick={() => {
                        setModalBonificaciones(false);
                      }}
                    >
                      Guardar
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
